import React from 'react';
import './LoadingSpinner.css';
import Unit from './Modular/Unit';
import { useWindowSize } from '../hooks/useWindowSize';

interface LoadingSpinnerProps {
  marginBottom?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ marginBottom }) => {
  const windowSize = useWindowSize();
  const mobileSpinner = windowSize.width <= 798 ? 'mobile' : '';

  return (
    <Unit marginBottom={marginBottom}>
      <div className={`spinner-overlay `}>
        <div className={`spinner ${mobileSpinner}`} />
      </div>
    </Unit>
  );
};

export default LoadingSpinner;
